import React, { useState } from 'react';
import { BaseManageModal } from './BaseManageModal';

/**
 * AssignFromUnsortedModal - Modal for assigning VMs from unsorted inventory
 */
export const AssignFromUnsortedModal = ({
    open,
    onCancel,
    onApply,
    moveGroups = [],
    applications = [],
    users = [],
    selectedRowKeys = [],
}) => {
    const [moveGroupDisabled, setMoveGroupDisabled] = useState(false);

    const handleApplicationChange = (applicationId, form) => {
        if (applicationId) {
            // Find the selected application
            const selectedApp = applications.find((app) => app.value === applicationId);

            if (selectedApp && selectedApp.move_group_ids && selectedApp.move_group_ids.length > 0) {
                // Auto-fill the move group field with the app's move group
                const moveGroupId = selectedApp.move_group_ids[0];
                form.setFieldsValue({ moveGroup: moveGroupId });
                setMoveGroupDisabled(true);
            } else {
                // App has no move group, allow selection
                setMoveGroupDisabled(false);
            }
        } else {
            // No app selected, enable move group field
            setMoveGroupDisabled(false);
        }
    };

    const handleApply = (values, form) => {
        // Transform values to match the expected format
        const payload = {
            moveGroup: values.moveGroup,
            application: values.application,
            resource: values.resource,
            date: values.date,
        };
        onApply?.(payload);
        form.resetFields();
        setMoveGroupDisabled(false);
    };

    const handleCancel = () => {
        setMoveGroupDisabled(false);
        onCancel?.();
    };

    return (
        <BaseManageModal
            open={open}
            onCancel={handleCancel}
            onApply={handleApply}
            title="Manage Source Assignment"
            description={`Assign ${selectedRowKeys.length > 0 ? `${selectedRowKeys.length} selected` : ''} source(s) to Move Group or Application`}
            selectedRowKeys={selectedRowKeys}
            showMoveGroupField
            showApplicationField
            showNote
            noteText="Note: A VM can only belong to one Move Group and one Application at a time."
            moveGroups={moveGroups}
            applications={applications}
            onApplicationChange={handleApplicationChange}
            moveGroupDisabled={moveGroupDisabled}
        />
    );
};
